import React, { useEffect, useRef, useState } from 'react';

const StatCounter = ({ target, label }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const animated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !animated.current) {
          animated.current = true;
          const duration = 2000;
          const start = performance.now();
          
          const update = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setCount(Math.floor(eased * target));
            if (progress < 1) requestAnimationFrame(update);
          };
          
          requestAnimationFrame(update);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div className="stat" ref={ref}>
      <div className="stat__number">{count}{target > 10 ? '+' : ''}</div>
      <div className="stat__label">{label}</div>
    </div>
  );
};

const Stats = () => (
  <section className="stats reveal">
    <StatCounter target={150} label="Proyectos Entregados" />
    <StatCounter target={98} label="% Satisfacción" />
    <StatCounter target={50} label="Clientes Activos" />
    <StatCounter target={5} label="Años de Experiencia" />
  </section>
);

export default Stats;
